import './main.js'

import DataTable from './components/DataTable'
import Selectize from './components/Selectize'
import Trumbowyg from './components/Trumbowyg'
import Admin from './components/Admin'
import Education from './components/Education'
import PDFViewerManager from './components/PDFViewerManager'
import Checkout from './components/Checkout'
import Blog from './components/Blog'
import Counter from './components/Counter'

document.addEventListener('DOMContentLoaded', () => {
  DataTable.init()
  Selectize.init()
  Trumbowyg.init()
  Admin.init()
  Education.init()
  PDFViewerManager.init()
  Checkout.init()
  Counter.init()
})

window.addEventListener('load', () => {
  Blog.init()
})




// WEBPACK FOOTER //
// app/javascript/scripts/main-jquery.js